import axios from 'axios'

const SIENA_URL = process.env.VUE_APP_SIENA_URL
const CREATE_ACCOUNT_URL = `${SIENA_URL}/accounts`
const CREATE_ACCOUNT_WITH_USER_URL = `${SIENA_URL}/users/me/accounts`
const VERIFY_DOCUMENT_URL = `${SIENA_URL}/accounts/document-available`
const VERIFY_LOGIN_URL = `${SIENA_URL}/accounts/login-available`

const DEFAULT_ERROR = `Desculpe, ocorreu um erro ao efetuar o cadastro.
Já identificamos o erro e estamos trabalhando para corrigi-lo o mais rápido possível.
Por favor, entre em contato com o nosso suporte.
`

const http = axios.create({ validateStatus: () => true })

async function verifyHelper(url, param, value) {
  const { status, data } = await http.get(url, {
    params: { [param]: value }
  })

  if (status !== 200) {
    return false
  }

  return data.available
}

export async function verifyEmail(accountId, code) {
  const url = `${SIENA_URL}/accounts/${accountId}/verification/email/verify`
  try {
    const { status } = await http.post(url, { code })
    if (status === 200) {
      return { verified: true }
    }
  } catch (e) {
    throw new Error(e.message || 'Não foi possível verificar o email')
  }
  return { verified: false }
}

export async function verifySms(accountId, code) {
  const url = `${SIENA_URL}/accounts/${accountId}/verification/sms/verify`
  try {
    const { status } = await http.post(url, { code })
    if (status === 200) {
      return { verified: true }
    }
  } catch (e) {
    throw new Error(e.message || 'Não foi possível verificar o sms')
  }
  return { verified: false }
}

export async function createAccountWithUser(authorization, account) {
  const { status, data } = await http.post(CREATE_ACCOUNT_WITH_USER_URL, account, {
    headers: {
      Authorization: authorization
    }
  })

  if (200 === status) {
    return data.id
  }

  throw new Error((data && data.error) || DEFAULT_ERROR)
}

export async function createAccount(authorization, account) {
  if (authorization) {
    return createAccountWithUser(authorization, account)
  }

  const { status, data } = await http.post(CREATE_ACCOUNT_URL, account)

  if (200 === status) {
    return data.id
  }

  throw new Error((data && data.error) || DEFAULT_ERROR)
}

export function verifyDocument(document) {
  return verifyHelper(VERIFY_DOCUMENT_URL, 'document', document)
}

export function verifyLogin(login) {
  return verifyHelper(VERIFY_LOGIN_URL, 'login', login)
}
